import { REPORT } from "../../Constant";
import {
  TrendingUp,
  DollarSign,
  CreditCard,
  CheckSquare,
  Percent,
  Landmark,
  Users,
  Package,
  AlertOctagon,
  Truck,
  ShoppingBag,
  RotateCcw,
  ClipboardList,
  FileText,
} from "lucide-react";

export interface ReportConfigItem {
  name: string;
  description: string;
  icon: any;
  iconColor: string;
  path: string;
  bgColor: string;
}

export const salesReportsList: ReportConfigItem[] = [
  {
    name: "Sales & Expense Ledger",
    description:
      "Unified cash book of sales, credit payments, incomes, and expenses with a running balance.",
    icon: TrendingUp,
    iconColor: "text-emerald-600",
    path: REPORT.sales_ledger,
    bgColor: "bg-emerald-50/50 border-emerald-100",
  },
  {
    name: "Item Profit Report",
    description:
      "Analyze individual sold item costs, selling prices, revenues, and net margins.",
    icon: DollarSign,
    iconColor: "text-blue-600",
    path: REPORT.item_profit,
    bgColor: "bg-blue-50/50 border-blue-100",
  },
  {
    name: "Cash Book (Cash In / Out)",
    description:
      "Review cash drawer openings, direct drawer deposits, and cash withdrawals.",
    icon: CreditCard,
    iconColor: "text-amber-600",
    path: REPORT.cash_flow,
    bgColor: "bg-amber-50/50 border-amber-100",
  },
  {
    name: "Cheque Ledger Report",
    description:
      "Monitor received or issued cheques, bank clearance accounts, and statuses.",
    icon: CheckSquare,
    iconColor: "text-purple-600",
    path: REPORT.cheques,
    bgColor: "bg-purple-50/50 border-purple-100",
  },
  {
    name: "Discount Report",
    description:
      "Track sales price adjustments, total cash discounts, and percentages.",
    icon: Percent,
    iconColor: "text-rose-600",
    path: REPORT.discounts,
    bgColor: "bg-rose-50/50 border-rose-100",
  },
  {
    name: "Card & Bank Payments",
    description:
      "Audit digital collections including credit card swipes and bank transfers.",
    icon: Landmark,
    iconColor: "text-cyan-600",
    path: REPORT.non_cash_payments,
    bgColor: "bg-cyan-50/50 border-cyan-100",
  },
  {
    name: "Employee Performance",
    description:
      "Track total sales count, volumes, margins, and expenses logged per staff member.",
    icon: Users,
    iconColor: "text-indigo-600",
    path: REPORT.employee_performance,
    bgColor: "bg-indigo-50/50 border-indigo-100",
  },
  {
    name: "Sign Off Reports",
    description:
      "Review cash register shift closings, denomination drops, and cash discrepancies.",
    icon: FileText,
    iconColor: "text-purple-600",
    path: REPORT.sign_off_list,
    bgColor: "bg-purple-50/30 border-purple-100",
  },
];

export const inventoryReportsList: ReportConfigItem[] = [
  {
    name: "Product Stock Report",
    description:
      "Check current quantity of products, average cost, average retail price, and total valuation.",
    icon: Package,
    iconColor: "text-indigo-600",
    path: REPORT.product_stock,
    bgColor: "bg-indigo-50/50 border-indigo-100",
  },
  {
    name: "Expiring Items Report",
    description:
      "Identify upcoming stock batch expirations with warning alerts to reduce waste.",
    icon: AlertOctagon,
    iconColor: "text-rose-600",
    path: REPORT.expiring_items,
    bgColor: "bg-rose-50/50 border-rose-100",
  },
  {
    name: "Purchases Summary",
    description:
      "Overview of inbound vendor procurements, order status, total costs, payments, and balances due.",
    icon: Truck,
    iconColor: "text-blue-600",
    path: REPORT.purchases,
    bgColor: "bg-blue-50/50 border-blue-100",
  },
  {
    name: "Purchased Items Detail",
    description:
      "Detailed itemized breakdown of products purchased from suppliers with unit cost and batch numbers.",
    icon: ShoppingBag,
    iconColor: "text-emerald-600",
    path: REPORT.purchased_products,
    bgColor: "bg-emerald-50/50 border-emerald-100",
  },
  {
    name: "Return Item Report",
    description:
      "Analyze items returned by customers categorized by quality condition (Good / Damaged / Expired).",
    icon: RotateCcw,
    iconColor: "text-amber-600",
    path: REPORT.returned_items,
    bgColor: "bg-amber-50/50 border-amber-100",
  },
  {
    name: "Sold Items Report",
    description:
      "Review granular logs of sold items, unit prices, discounts applied, and totals per transaction.",
    icon: ClipboardList,
    iconColor: "text-cyan-600",
    path: REPORT.sold_items,
    bgColor: "bg-cyan-50/50 border-cyan-100",
  },
];
